import * as types from '../actionTypes/CartActionTypes';

export default function CartAnalyticsReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case types.UPDATE_ANALYTICS_CLICK_EVENT:
            return action.payload;
        default:
            return state;
    }
}
